"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
require("@gibme/web-ui");
const ip_address_1 = require("ip-address");
const fetch_feed = () => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield $.fetch('./geofeed.csv');
    const results = [];
    if (response.ok) {
        const text = yield response.text();
        const records = text.split('\n')
            .map(elem => elem.trim())
            .filter(elem => elem.length !== 0);
        for (const record of records) {
            const [ip, country, region, city, zipcode] = record.split(',');
            const address = new ip_address_1.Address4(ip);
            const state = region.split('-')[1] || '';
            results.push({
                address,
                country,
                state,
                city,
                zipcode
            });
        }
    }
    return results;
});
const to_address = (value) => {
    try {
        return new ip_address_1.Address4(value);
    }
    catch (_a) { }
};
$(() => __awaiter(void 0, void 0, void 0, function* () {
    const search_button = $('#search');
    const ipaddress = $('#ipaddress');
    const results = $('#results');
    const prefix = $('#prefix');
    const country = $('#country');
    const city = $('#city');
    const state = $('#state');
    const zip = $('#zip');
    const geofeed = yield fetch_feed();
    search_button.on('click', () => {
        const lookup = ipaddress.val().trim();
        const address = to_address(lookup);
        if (address) {
            let found = false;
            ipaddress.removeClass('is-invalid');
            for (const record of geofeed) {
                if (address.isInSubnet(record.address)) {
                    found = true;
                    results.removeClass('d-none');
                    prefix.val(record.address.address);
                    country.val(record.country);
                    city.val(record.city);
                    state.val(record.state);
                    zip.val(record.zipcode);
                    break;
                }
            }
            if (!found) {
                results.addClass('d-none');
            }
        }
        else {
            results.addClass('d-none');
            return ipaddress.addClass('is-invalid');
        }
    });
}));
